import { AppValueTypes } from '@iotv/iotv-v3-types';
import { NormalCase } from '../../NetworkSystem/cellFormatters/valueFormatters';
export const NetworkListViewDefintion = {
    name: {
        key: 'name',
        type: AppValueTypes.STRING,
        label: 'Name',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    state: {
        key: 'state',
        type: AppValueTypes.STRING,
        label: 'State',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    gatewayCount: {
        key: 'gatewayCount',
        type: AppValueTypes.STRING,
        label: 'Gateways',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    dailyUpCount: {
        key: 'dailyUpCount',
        type: AppValueTypes.NUMBER,
        label: 'Daily Up Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    dailyDownCount: {
        key: 'dailyDownCount',
        type: AppValueTypes.NUMBER,
        label: 'Daily Down Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    deviceCount: {
        key: 'deviceCount',
        type: AppValueTypes.NUMBER,
        label: 'Device Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    fCntJump: {
        key: 'fCntJump',
        type: AppValueTypes.NUMBER,
        label: 'Frame Count Jump',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastHourDevCount: {
        key: 'lastHourDevCount',
        type: AppValueTypes.NUMBER,
        label: 'Last Hr Device Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastHourMsgCount: {
        key: 'lastHourMsgCount',
        type: AppValueTypes.NUMBER,
        label: 'Last Hr Message Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastDayMsgCount: {
        key: 'lastDayMsgCount',
        type: AppValueTypes.NUMBER,
        label: 'Last Day Message Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    lastDayDeviceCount: {
        key: 'lastDayDeviceCount',
        type: AppValueTypes.NUMBER,
        label: 'Last Day Device Count',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
    battery: {
        key: 'battery',
        type: AppValueTypes.NUMBER,
        label: 'Battery',
        editable: false,
        precision: undefined,
        stateFn: undefined,
        unit: undefined,
        validationRx: undefined,
        enumKV: undefined,
    },
};
export const NetworkColumnMap = {
    name: {
        headerName: 'Name',
        width: 200,
    },
    state: {
        headerName: 'State',
        valueFormatter: NormalCase,
        width: 100,
    },
    gatewayCount: {
        headerName: 'Gateway',
        width: 100,
    },
    dailyUpCount: {
        headerName: 'Daily Up Count',
        width: 150,
    },
    dailyDownCount: {
        headerName: 'Daily Down Count',
        width: 150,
    },
    deviceCount: {
        headerName: 'Device Count',
        width: 150,
    },
    channelMessage: {
        headerName: 'Message Count',
        width: 180,
    },
    fCntJump: {
        headerName: 'Frame Count Jump',
        width: 150,
    },
    lastHourDevCount: {
        headerName: 'Last Hr Device Count',
        width: 150,
    },
    lastHourMsgCount: {
        headerName: 'Last Hr Message Count',
        width: 150,
    },
    lastDayMsgCount: {
        headerName: 'Last Day Message Count',
        width: 150,
    },
    lastDayDeviceCount: {
        headerName: 'Last Day Device Count',
        width: 150,
    },
    battery: {
        headerName: 'Battery',
        width: 100,
    },
};
// export const NetworkListContextViewKeyDefinitions: ViewDefinition = {
//   customerGroup: {
//     key: 'customerGroup',
//     type: AppValueTypes.STRING,
//     label: 'Customer Group',
//     editable: false,
//     precision: undefined,
//     stateFn: undefined,
//     unit: undefined,
//     validationRx: undefined,
//     enumKV: undefined,
//   },
//   customer: {
//     key: 'customer',
//     type: AppValueTypes.STRING,
//     label: 'Customer',
//     editable: false,
//     precision: undefined,
//     stateFn: undefined,
//     unit: undefined,
//     validationRx: undefined,
//     enumKV: undefined,
//   },
//   gatewayGroup: {
//     key: 'gatewayGroup',
//     type: AppValueTypes.STRING,
//     label: 'Gateway Group',
//     editable: false,
//     precision: undefined,
//     stateFn: undefined,
//     unit: undefined,
//     validationRx: undefined,
//     enumKV: undefined,
//   },
//   property: {
//     key: 'property',
//     type: AppValueTypes.STRING,
//     label: 'Property',
//     editable: false,
//     precision: undefined,
//     stateFn: undefined,
//     unit: undefined,
//     validationRx: undefined,
//     enumKV: undefined,
//   },
// };
